import { Accordion, Div, Text, Title } from "view/lib/components";

interface Props {
  readonly data: Record<string, any>;
}

const Portfolio = ({ data }: Props) =>
  <Div style={styles.container}>
    <Title title="Portfolio" />
    <Div>
      <Text style={styles.sectionTitle}>Work Experience</Text>
      {data.work.map((employment: Record<string, any>) =>
        <Accordion
          key={employment.employer}
          title={employment.employer}
          item={employmentItem(employment)} />)}
    </Div>
    <Div>
      <Text style={styles.sectionTitle}>Projects</Text>
      {data.projects.map((project: Record<string, any>) =>
        <Accordion
          key={project.name}
          title={project.name}
          item={projectItem(project)} />)}
    </Div>
  </Div>;

const projectItem = (project: Record<string, any>) =>
  <>
    <ul style={styles.list}>
      {project.description.map((line: string) =>
        <li key={project.name}>
          <Text>{line}</Text>
        </li>)}
    </ul>
    <a href={project.link} target="_blank"><Text>Go To Project</Text></a>
  </>;

const employmentItem = (employment: Record<string, any>) =>
  <>
  <Text>Duration: {employment.duration}</Text>
  <Text>Role: {employment.role}</Text>
  <Text>Type: {employment.type}</Text>
  <ul style={styles.list}>
    {employment.description.map((line: string, index: number) =>
      <li key={`${employment.name}_${index}`}>
        <Text>{line}</Text>
      </li>)}
  </ul>
  <a href={employment.link} target="_blank"><Text>Go To Website</Text></a>
  </>

const styles = {
  container: {
    padding: "2%"
  },
  title: {
    fontSize: "xx-large"
  },
  sectionTitle: {
    fontSize: "x-large"
  },
  list: {
    listStyleType: "circle"
  }
}

export default Portfolio;